<template>
  <div>
    <div class="floated-colors-btn second-floated-btn" style="z-index: 1010 !important" @click="cambiarUiTabla">
      <div class="os-toggler-w" :class="{ on: cambiar_UiTabla }">
        <div class="os-toggler-i">
          <div class="os-toggler-pill"></div>
        </div>
      </div>
      <span v-if="!cambiar_UiTabla">Tabla Detalle</span>
      <span v-if="cambiar_UiTabla">Tabla Resumen</span>
    </div>
    <div style="z-index: 1000 !important" class="floated-chat-btn" v-if="!current.fecha_asignacion"
      @click="asignarTareaModal()">
      <i class="fas fa-check"></i>&nbsp;&nbsp;Asignar Tarea
    </div>

    <div class="support-ticket-content-w">
      <div class="support-ticket-content">
        <div>
          <div>
            <div style="text-align:left;">
              <a style="
              padding-top: 0px;
              padding-bottom: 5px;
              font-size: 12px;
              color: #7646ad;
              letter-spacing: 1px;
              font-weight: bold;
            " @click="regresarClick">
                <i class="os-icon os-icon-arrow-left5"></i>
                <span>REGRESAR</span>
              </a>
            </div>
            <div style="text-align:right;">
              <a style="
                  text-align: right; 
                  padding-top: 0px;
                  padding-bottom: 5px;">
                <button class="btn btn-sm btn-dark" type="button" @click="showhidediv()">
                  Búsqueda Avanzada &nbsp;
                  <i class="fas fa-search"></i>
                </button>
              </a>
            </div>
          </div>
          <br>
          <div class="row col-12">
            <div class="col-12" style="display: none;" id="fyb">
              <div class="row">
                <div class="col-8">
                  <input class="form-control form-control-sm" placeholder="SKU, e.g. A02497" v-model="filtro_producto"
                    type="text" v-on:keyup.enter="refreshProductoSearch(filtro_producto)" id="filtro1" />
                </div>
                <div class="row">
                  <div class="col-5">
                    <button class="btn btn-md btn-success" type="button"
                      @click="refreshProductoSearch(filtro_producto)">
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                  <div class="col-5">
                    <button @click="refresh_tarea()" class="btn btn-md btn-danger" type="button">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div>
                <SubCategoriaSelectComponent :current="filter_subcategoria" @change="refresSubcategoriaSearch()"
                  title="" />
              </div>
            </div>
          </div>
          <hr>
          <div class="col-12">
            <div style="text-align: center; font-size: 20px;">
              <span> Tarea </span>#{{ current.numero }}
            </div>
          </div>
          <div>
            <a class="text-center font-weight-bold" style="padding: 0px; height: 1px">
              <span class="text-success">De:</span>
              {{ current.tienda_origen_obj.nombre }}
            </a>
            <br>
            <a class="text-center font-weight-bold" style="padding: 0px; height: 1px">
              <span class="text-success">Hacia:</span>
              {{ current.tienda_destino_obj.nombre }}
            </a>
          </div>
          <div style="text-align: left;">
            <span class="text-center font-weight-bold" style="padding: 0px; height: 1px;">
              <span class="text-success"> Usuario: </span>{{ current.usuario.username }} - {{ current.usuario.id }}
            </span>
          </div>
          <div class="col-12">
            <br />
            <div class="row">
              <div class="col-6" style="border-right: #63cb4e 2px solid; border-bottom: #63cb4e 2px solid">
                <table class="table">
                  <thead></thead>
                  <tbody>
                    <tr>
                      <td class="text-success" style="padding: 0px; height: 1px; background-color: rgb(244, 244, 244);">
                        Tipo de SKU en Tarea
                      </td>
                      <td style="background-color: rgb(244, 244, 244);">
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 0px; height: 1px">
                        Normal
                      </td>
                      <td style="padding: 0px; height: 1px">
                        {{ current.tipo.normal }}
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 0px; height: 1px">
                        Punta Góndola
                      </td>
                      <td style="padding: 0px; height: 1px">
                        {{ current.tipo.punta_gondola }}
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 0px; height: 1px">
                        Mayoreo
                      </td>
                      <td style="padding: 0px; height: 1px">
                        {{ current.tipo.pedido_mayoreo }}
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 0px; height: 1px">
                        Automáticos
                      </td>
                      <td style="padding: 0px; height: 1px">
                        {{ current.tipo.automatico }}
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 0px; height: 1px">
                        Insumos
                      </td>
                      <td style="padding: 0px; height: 1px">
                        {{ current.tipo.insumo }}
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 0px; height: 1px">
                        Próximos a Vencer
                      </td>
                      <td style="padding: 0px; height: 1px">
                        {{ current.tipo.proximo_vencer }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-6" style="border-bottom: #63cb4e 2px solid">
                <table class="table">
                  <thead></thead>
                  <tbody>
                    <tr>
                      <td class="text-success text-center"
                        style="padding: 0px; height: 1px; background-color: rgb(244, 244, 244);">
                        Status Pick Producto
                      </td>
                      <td style="background-color: rgb(244, 244, 244);"></td>
                    </tr>
                    <tr>
                      <td style="padding: 0px; height: 1px">
                        <span>Pendiente</span>
                      </td>
                      <td>
                        <div style="background-color: rgb(255, 255, 255);
                                      width: 25px; height: 12px; 
                                      border:1px solid black;">
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 0px; height: 1px">
                        <span>Completo</span>
                      </td>
                      <td>
                        <div style="background-color: rgb(226, 255, 213);
                                      width: 25px; height: 12px; 
                                      border:1px solid black;">
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 0px; height: 1px">
                        <span>Incompleto</span>
                      </td>
                      <td>
                        <div style="background-color: rgb(255, 235, 181);
                                      width: 25px; height: 12px; 
                                      border:1px solid black;">
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td style="padding: 0px; height: 1px">
                        <span>No Picking</span>
                      </td>
                      <td>
                        <div style="background-color: rgb(255, 212, 223);
                                      width: 25px; height: 12px; 
                                      border:1px solid black;">
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <LogModalComponent modulo="wms" transac="tareas" :id="current.id" />
            <ModalAsignarProductosACarritoComponent :id_tarea="current.id" v-if="current.estado == 'A'"
              @refresh_tarea="refresh_tarea" @refresh_tarea_finalizada="regresarClick" @abrirLog="abrirLog()" />
          </div>
        </div>
        <br>
        <button @click="refresh_tarea()" class="btn btn-sm btn-dark">
          Actualizar Info. <i class="fas fa-sync"></i>
        </button>
      </div>
      <DescripcionTareaModalComponent :existencia="existencia" :detalle="detalle" :current="current"
        @refresh="refresh_tarea()" />
      <ModalPickearComponent v-if="current.estado == 'A'" :tarea="current" @refresh_tarea="refresh_tarea" />
    </div>
    <div class="row mt-2" id="bodycontent">
      <div class="col-lg-12">
        <div v-if="!cambiar_UiTabla" class="padded-lg">
          <!--START - Projects list-->
          <div class="projects-list">
            <div class="project-box" v-for="detalle in current.detalle" :key="detalle.id"
              @click="abrirModalDescripcion(detalle)">
              <div class="project-head" style="padding-right: 1em; padding-left: 1em" v-bind:style="detalle.motivo_no_picking != null
                ? 'background-color: #FFD4DF;'
                : detalle.status_picking == 'sin_pickear'
                  ? 'background-color: #FFFFFF;'
                  : detalle.status_picking == 'motivo_no_picking'
                    ? 'background-color: #FFFFFF;'
                  : detalle.status_picking == 'sobre_pickeado'
                    ? 'background-color: #1216D4;'
                    : detalle.status_picking == 'pendiente_pickear'
                      ? 'background-color: #FFEBB5;'
                      : detalle.status_picking == 'pickeo_finalizado'
                        ? 'background-color: #E2FFD5;'
                        : detalle.status_picking == 'sin_existencia'
                          ? 'background-color: #FFECEC;'
                          : 'color: #929292;'
                ">
                <div class="project-title">
                  <h5>
                    {{ detalle.producto_obj.sku }}
                  </h5>
                  <small>{{ detalle.producto_obj.nombre }}</small>
                </div>

                <div class="badge badge-success" v-if="detalle.producto_obj.categoria">
                  {{ detalle.producto_obj.categoria.nombre }}
                </div>
                &nbsp;
                <div class="badge badge-blue">
                  <span v-if="detalle.tipo_tarea == 'P'">PRÓXIMO A VENCER</span>
                </div>
                &nbsp;
                <div class="badge badge-dark">
                  <span v-if="detalle.tipo_tarea == 'G'">PUNTA DE GÓNDOLA</span>
                  <span v-if="detalle.tipo_tarea == 'M'">PEDIDO MAYOREO</span>
                </div>
                &nbsp;
                <div class="badge badge-info">
                  <span v-if="detalle.tipo_tarea == 'N'">NORMAL</span>
                  <span v-if="detalle.tipo_tarea == 'A'">AUTOMÁTICO</span>
                  <span v-if="detalle.tipo_tarea == 'I'">INSUMO</span>
                </div>
                <br />
                <div class="badge badge-default" v-for="_barra in detalle.producto_obj.barras" :key="_barra">
                  {{ _barra }}
                </div>
                <div class="row align-items-center">
                  <div class="col-sm-5">
                    <div class="row">
                      <div class="col-6">
                        <div class="el-tablo highlight">
                          <div class="label">Solicitada</div>
                          <h5 style="color: #30bf19">
                            {{ detalle.cantidad_solicitada }}
                          </h5>
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="el-tablo highlight">
                          <div class="label">Pendiente</div>
                          <h5 style="color: #30bf19">
                            {{ detalle.pendiente_pickear }}
                          </h5>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="el-tablo highlight">
                          <div class="label">Pickeado</div>
                          <div>
                            {{ detalle.cant_pickeada }}
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="el-tablo highlight">
                          <div class="label">Carrito</div>
                          <div>
                            {{ detalle.cant_actual_en_carrito }}
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="el-tablo highlight">
                          <div class="label">Estacionada</div>
                          <div>
                            {{ detalle.cant_asignada_estacion }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-5 offset-sm-2">
                    <div class="os-progress-bar primary">
                      <div class="bar-labels">
                        <div class="bar-label-left">
                          <span>Pickeado:</span>
                        </div>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <div class="bar-label-right col-9">
                          <div class="progress" style="height: 1.3rem">
                            <div class="progress-bar progress-bar-striped bg-success progress-bar-animated"
                              role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" :style="{
                                width: detalle.porc_pickeado + '%',
                              }">
                              <a style="color: black">{{ detalle.porc_pickeado }}%</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="os-progress-bar primary">
                      <div class="bar-labels">
                        <div class="bar-label-left">
                          <span>Estacionado:</span>
                        </div>
                        <div class="bar-label-right col-9">
                          <div class="progress" style="height: 1.3rem">
                            <div class="progress-bar progress-bar-striped bg-success progress-bar-animated"
                              role="progressbar" :style="{
                                width: detalle.porc_asignada_estacion + '%',
                              }">
                              <a style="color: black">{{ detalle.porc_asignada_estacion }}%</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--END - Projects list-->
        </div>
        <div v-if="cambiar_UiTabla">
          <table class="table table-hover">
            <thead>
              <tr>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr class="project-box" v-for="det in current.detalle" :key="det.id"
                @click="abrirModalDescripcion(detalle)">
                <td v-bind:style="det.motivo_no_picking != null
                  ? 'background-color: #FFD4DF;'
                  : det.status_picking == 'sin_pickear'
                    ? 'background-color: #FFFFFF;'
                    : det.status_picking == 'motivo_no_picking'
                      ? 'background-color: #FFFFFF;'
                      : det.status_picking == 'sobre_pickeado'
                      ? 'background-color: #1216D4;'
                      : det.status_picking == 'pendiente_pickear'
                        ? 'background-color: #FFEBB5;'
                        : det.status_picking == 'pickeo_finalizado'
                          ? 'background-color: #E2FFD5;'
                          : det.status_picking == 'sin_existencia'
                            ? 'background-color: #FFECEC;'
                            : 'color: #929292;'
                  ">
                  <div class="value">
                    <small class="font-weight-bold">{{ det.producto_obj.sku }}</small>
                  </div>
                  <small>
                    <div class="value">
                      {{ det.producto_obj.nombre }}
                    </div>
                  </small>
                  Pickeada:
                  <span class="sub-value font-weight-bold text-success">
                    {{ det.cant_pickeada }}
                    <i v-if="det.cant_pickeada == det.cantidad_solicitada" class="fas fa-check"></i>
                  </span>
                </td>
                <td v-bind:style="det.motivo_no_picking != null
                  ? 'background-color: #FFD4DF;'
                  : det.status_picking == 'sin_pickear'
                    ? 'background-color: #FFFFFF;'
                    : det.status_picking == 'motivo_no_picking'
                      ? 'background-color: #FFFFFF;'
                    : det.status_picking == 'sobre_pickeado'
                      ? 'background-color: #1216D4;'
                      : det.status_picking == 'pendiente_pickear'
                        ? 'background-color: #FFEBB5;'
                        : det.status_picking == 'pickeo_finalizado'
                          ? 'background-color: #E2FFD5;'
                          : det.status_picking == 'sin_existencia'
                            ? 'background-color: #FFECEC;'
                            : 'color: #929292;'
                  ">
                  <div class="badge badge-info" v-if="det.producto_obj.categoria">
                    {{ det.producto_obj.categoria.nombre }}
                  </div>
                  <br />
                  Solicitada:
                  <span class="sub-value font-weight-bold" style="color: blue">
                    {{ det.cantidad_solicitada }}
                  </span>

                  <br />
                  Estacionada:
                  <span class="sub-value font-weight-bold text-success">
                    {{ det.cant_asignada_estacion }}
                    <i v-if="det.cant_pickeada == det.cant_asignada_estacion &&
                      det.cant_asignada_estacion > 0
                    " class="fas fa-check"></i>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalPickearComponent from "@/components/wms/tareas/ModalPickearComponent";
import DescripcionTareaModalComponent from "@/components/wms/tareas/DescripcionTareaModalComponent";
import ModalAsignarProductosACarritoComponent from "@/components/wms/tareas/ModalAsignarProductosACarritoComponent";
import SubCategoriaSelectComponent from "@/components/commons/SubCategoriaSelectComponent ";
import DynamicService from "@/services/commons/DynamicService";
import LogModalComponent from "@/components/commons/LogModalComponent";

export default {
  components: {
    ModalPickearComponent,
    ModalAsignarProductosACarritoComponent,
    DescripcionTareaModalComponent,
    LogModalComponent,
    SubCategoriaSelectComponent,
  },
  props: {
    current: {
      type: Object,
    },
    lista: {
      type: Array,
    },
  },
  data() {
    return {
      cambiar_UiTabla: false,
      filtro_producto: "",
      errors: { producto: "" },
      items: [],
      detalle: "",
      existencia: "",
      filter_subcategoria: {},
    };
  },
  mounted() { },
  methods: {
    abrirLog() {
      $("#modalLog").modal("show");
    },
    abrirModalDescripcion(detalle) {
      this.detalle = detalle;
      // if (detalle.cant_pickeada == detalle.cantidad_solicitada) {
      //   return;
      // }
      if (this.current.estado == "A") {
        this.existenciaProductoTienda(this.detalle.producto);
        $("#descripcionModal").modal("show");
      }
    },
    filterData(producto) {
      let self = this;
      let item = [];
      item = self.lista.filter(function (det) {
        return det.producto == producto;
      });
      if (item.length > 0) {
        self.items.push(item[0]);
      }
    },
    refresSubcategoriaSearch() {
      let self = this;
      self.items = [];
      if (self.filter_subcategoria.subcategoria == null) {
        self.refresh_tarea();
        return;
      }
      DynamicService.getActionList(
        "cat",
        "subcategoria",
        "traer_productos_Subcategoria",
        {
          subcategoria: self.filter_subcategoria.subcategoria.codigo,
        }
      )
        .then((response) => {
          self.productos = response.data;
          if (self.productos.length > 0) {
            for (const i in self.productos) {
              self.filterData(self.productos[i].producto);
            }
          }
          if (self.items.length == 0) {
            self.current.detalle = "";
            return;
          }
          self.current.detalle = self.items;
        })
        .catch((err) => {
          self.current.detalle = self.lista;
          alert("Producto no existe");
          this.filtro_producto = "";
        });
    },
    refreshProductoSearch(barra) {
      let self = this;
      self.items = [];
      if (!barra) {
        self.current.detalle = self.lista;
        return;
      }
      DynamicService.fetch("cat", "productos", {
        "filter[search]": barra,
        activo: true,
        quitar_paginacion: true,
      })
        .then((response) => {
          self.productos = response.data;
          if (self.productos.length > 0) {
            for (const i in self.productos) {
              self.filterData(self.productos[i].sku);
            }
          }
          if (self.items.length == 0) {
            self.current.detalle = "";
            return;
          }
          self.current.detalle = self.items;
        })
        .catch((err) => {
          self.current.detalle = self.lista;
          alert("Producto no existe");
          this.filtro_producto = "";
        });
    },
    refreshProducto(barra) {
      let self = this;
      if (!barra) {
        return;
      }
      DynamicService.fetch("cat", "producto-barra", {
        barra: barra,
        activo: true,
      })
        .then((response) => {
          self.producto = response.data.results[0].producto_obj;
          self.errors.producto = "";
          self.error_pickeo = "";
        })
        .catch((err) => {
          alert("Producto no existe");
          this.filtro_producto = "";
        });
    },
    cambiarUiTabla() {
      let self = this;
      self.cambiar_UiTabla = !self.cambiar_UiTabla;
    },
    regresarClick() {
      this.$emit("regresar");
    },
    refresh_tarea() {
      this.filtro_producto = "";
      this.filter_subcategoria.subcategoria = "";
      this.$emit("seleccionarTarea", this.current.id);
    },
    showhidediv() {
      var x = document.getElementById("fyb");
      if (x.style.display === "none") {
        x.style.display = "block";
      } else {
        x.style.display = "none";
      }
    },
    existenciaProductoTienda(producto) {
      let self = this;
      DynamicService.getAction(
        "cat",
        "productos",
        producto,
        "existencia_producto_tienda_no_calculada",
        {
          tienda: self.current.tienda_origen,
        }
      )
        .then((response) => {
          self.existencia = response.data.cantidad;
        })
        .catch((error) => {
          alert("error");
          1;
        });
    },
  },
};
</script>
